import React, { useRef } from 'react';

/**
 * A request-editor tab whose content stays mounted once it has been opened,
 * and is only hidden while another tab is shown.
 *
 * For the Body tab: unmounting it threw away its Monaco editor, and coming
 * back rebuilt the model from the whole body — about a second for a 9.5 MB XML,
 * where Postman (which keeps it) answers in under 100 ms. Kept, it also comes
 * back where it was scrolled to. Never opened, it costs nothing.
 *
 * Same box as RequestTabBody's `fixed` variant: the editor inside scrolls itself.
 */
export default function KeptTabPane({ active, children }) {
  const opened = useRef(false);
  if (active) opened.current = true;
  if (!opened.current) return null;
  return (
    <div
      className="flex-1 min-h-0 overflow-hidden px-0 pt-3 pb-4"
      // inline, not Tailwind's `hidden`: this app's build has no rule for it
      style={active ? undefined : { display: 'none' }}
      data-testid={active ? 'request-tab-body' : undefined}
      aria-hidden={active ? undefined : true}
    >
      {children}
    </div>
  );
}
